interface Props {
  log: string | null
  label?: string
}

export default function LogTail({ log, label = 'Log tail' }: Props) {
  return (
    <div style={cardStyle}>
      <div style={cardTitleStyle}>{label}</div>
      {log ? (
        <pre style={preStyle}>{log}</pre>
      ) : (
        <p style={{ color: '#aaa', fontSize: 13, margin: 0 }}>No log available</p>
      )}
    </div>
  )
}

const cardStyle: React.CSSProperties = {
  background: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: 6,
  padding: '14px 16px',
}

const cardTitleStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 700,
  color: '#333',
  marginBottom: 10,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
}

const preStyle: React.CSSProperties = {
  margin: 0,
  fontSize: 12,
  fontFamily: 'monospace',
  background: '#1a1a2e',
  color: '#c8d6e5',
  padding: '12px 14px',
  borderRadius: 4,
  overflowX: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
  maxHeight: 260,
  overflowY: 'auto',
}
